// import { delegate} from "jquery-events-to-dom-events";

export default function initializeWooForms() {
    initializeQuantityFields();
    showShippingAddressForm();
    showInvoiceEmailForm();
    autoUpdateCart();
    window.initializeQuantityFields= initializeQuantityFields;
}


function initializeQuantityFields() {
    console.log('initializeQuantityFields');
    let quantityFields = document.querySelectorAll('.quantity .qty');

    quantityFields.forEach((item) => {
        initializeQuantityField(item);
    });
}

const initializeQuantityField = (item) => {
    let subButton = document.createElement('div'),
        addButton = document.createElement('div');

    subButton.className = 'quantity__button quantity__button--sub';
    subButton.textContent = '-';
    addButton.className = 'quantity__button quantity__button--add';
    addButton.textContent = '+';

    item.parentNode.insertBefore(subButton, item);
    item.parentNode.insertBefore(addButton, item.nextSibling);


    subButton.addEventListener('click', (e) => {
        e.preventDefault();

        let value = parseInt(item.value);

        if (value > 1) {
            item.value = value - 1;
            possiblyUnlockUpdateCartButton();
        }
    });

    addButton.addEventListener('click', (e) => {
        e.preventDefault();
        item.value = parseInt(item.value) + 1;
        possiblyUnlockUpdateCartButton();
    });
}

const possiblyUnlockUpdateCartButton = () => {
    let updateButton = document.querySelector('.woocommerce-cart-form button[name="update_cart"]')

    if (updateButton) {
        updateButton.removeAttribute('disabled')
        updateButton.setAttribute('aria-disabled', 'false');
    }
}


const showShippingAddressForm = () => {
    let formShipping = document.querySelector('.shipping_address');
    let shipToDifferentAddress = document.querySelector('#ship-to-different-address-checkbox');

    if (!formShipping || !shipToDifferentAddress) return;

    if (shipToDifferentAddress.checked) {
        formShipping.classList.remove('shipping_address--hidden');
    }

    shipToDifferentAddress.addEventListener('change', (e) => {
        if (e.target.checked) {
            formShipping.classList.remove('shipping_address--hidden');
        } else {
            formShipping.classList.add('shipping_address--hidden');
        }
    });

}


const showInvoiceEmailForm = () => {
    let paperForm = document.querySelector('.invoice_shipping_paper_form');
    let emailForm = document.querySelector('.invoice_shipping_email_form');
    // przy zmianie radio buttona, jeśli jest zaznaczony billing_invoice_form to pokazuj pole email
    let radioInvoiceType = document.querySelectorAll('input[name="invoice_shipping_selector"]');
    let radioInvoiceEmail = document.querySelector('#invoice_shipping_selector_email');
    let radioInvoicePaper = document.querySelector('#invoice_shipping_selector_paper');

    if (!paperForm || !emailForm || !radioInvoiceType || !radioInvoiceEmail) return;

    if (radioInvoiceEmail.checked) {
        paperForm.classList.add('invoice_shipping_paper_form--hidden');
        emailForm.classList.remove('invoice_shipping_email_form--hidden');
    } else if (radioInvoicePaper.checked) {
        paperForm.classList.remove('invoice_shipping_paper_form--hidden');
        emailForm.classList.add('invoice_shipping_email_form--hidden');
    }

    radioInvoiceType.forEach((item) => {
        item.addEventListener('change', (e) => {
            if (e.target.value === 'email') {
                paperForm.classList.add('invoice_shipping_paper_form--hidden');
                emailForm.classList.remove('invoice_shipping_email_form--hidden');
            } else if (e.target.value === 'paper') {
                paperForm.classList.remove('invoice_shipping_paper_form--hidden');
                emailForm.classList.add('invoice_shipping_email_form--hidden');
            }
        });
    });
}

const autoUpdateCart = () => {
    var timeout;

    document.querySelectorAll( '.woocommerce input.qty' ).forEach( function( input ) {
        input.addEventListener( 'change', function( e ) {
            if (timeout !== undefined) {
                clearTimeout( timeout );
            }
            timeout = setTimeout( function() {
                document.querySelector( '[name="update_cart"]' ).click(); // trigger cart update
            }, 800 ); // 1 second delay, half a second (500) seems comfortable too
        } );
    } );

    document.addEventListener( 'click', function( e ) {
        if (e.target.classList.contains( 'quantity__button' )) {
            if (timeout !== undefined) {
                clearTimeout( timeout );
            }
            timeout = setTimeout( function() {
                document.querySelector( '[name="update_cart"]' ).click(); // trigger cart update
            }, 800 ); // 1 second
        }
    } );
}